<template>
  <!-- custom-form-common-info3 .cfci3 -->
  <div class="cfci">
    <div class="my-info">
      <div class="my-info-box">
        <div class="my-info-box-r">所属公司:</div>
        <div class="my-info-box-l">
          <Input v-model="company" style="width: 100%" />
        </div>
      </div>
      <div class="my-info-box2">
        <div class="my-info-box z-half">
          <div class="my-info-box-r">创立年份:</div>
          <div class="my-info-box-l">
            <Input v-model="year" style="width: 120px" />
          </div>
        </div>
      </div>
      <div class="my-info-box z-half">
        <div class="my-info-box-r">店铺类型:</div>
        <div class="my-info-box-l">
          <Select v-model="type" style="width:120px" placeholder>
            <Option v-for="item in storeList" :value="item.value" :key="item.value">{{ item.value }}</Option>
          </Select>
        </div>
      </div>
      <div class="my-info-box z-half">
        <div class="my-info-box-r">单店投入:</div>
        <div class="my-info-box-l">
          <Input v-model="value" style="width: 120px" />
        </div>
        <span class="my-info-txt">万元</span>
      </div>
      <div class="my-info-box z-half">
        <div class="my-info-box-r">直营店:</div>
        <div class="my-info-box-l">
          <Input v-model="value1" style="width: 120px" />
        </div>
      </div>
      <div class="my-info-box z-half">
        <div class="my-info-box-r">旗舰店:</div>
        <div class="my-info-box-l">
          <Input v-model="value2" style="width: 120px" />
        </div>
        <span class="my-info-txt">家</span>
      </div>
      <div class="my-info-box z-half">
        <div class="my-info-box-r">加盟店:</div>
        <div class="my-info-box-l">
          <Input v-model="value3" style="width: 120px" />
        </div>
        <span class="my-info-txt">家</span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  // 领域类型 - 公司 创立年份 等详细信息
  name: "custom-form-common-info3",
  props: {
    field: {
      type: Object,
      default: { List: [], TypeId: 8 }
    }
  },
  model: {
    prop: "field",
    event: "sendField"
  },
  data() {
    return {
      fieldData: [],
      tag: [],
      popVisible: false, // 显示选择tag
      company: "",
      year: "",
      type: "",
      value: "",
      value1: "",
      value2: "",
      value3: "",
      myModel: { List: [], TypeId: 8 },
      storeType: 9, // 9 店铺类型
      storeList: null,
      typeList: [
        {
          value: "New York",
          label: "New York"
        },
        {
          value: "London",
          label: "London"
        }
      ]
    };
  },
  watch: {
    company(val, oldVal) {
      this.setModel();
    },
    year(val, oldVal) {
      this.setModel();
    },
    type(val, oldVal) {
      this.setModel();
    },
    value(val, oldVal) {
      this.setModel();
    },
    value1(val, oldVal) {
      this.setModel();
    },
    value2(val, oldVal) {
      this.setModel();
    },
    value3(val, oldVal) {
      this.setModel();
    }
  },
  async created() {
    let data = await this.getActionType(this.storeType);
    if (data && data.length > 0) {
      this.storeList = data; 
    }
    this.init();
  },
  methods: {
    ...mapActions({
      getActionType: "companyModule/getActionType"
    }),
    init() {
      console.log("this.field: (info3) ", this.field);
      if (this.field && this.field.List) {
        this.field.List.forEach(c => {
          if (c.Value === "所属公司") {
            this.company = c.Remark;
          }
          if (c.Value === "创立年份") {
            this.year = c.Remark;
          }
          if (c.Value === "店铺类型") {
            this.type = c.Remark;
          }
          if (c.Value === "单店投入") {
            this.value = c.Remark;
          }
          if (c.Value === "研发人数") {
            this.value1 = c.Remark;
          }
          if (c.Value === "旗舰店") {
            this.value2 = c.Remark;
          }
          if (c.Value === "加盟店") {
            this.value3 = c.Remark;
          }
        });
      }
    },
    setModel() {
      this.myModel.List = [];
      if (this.company) {
        this.myModel.List.push({
          TypeId: -1,
          Value: "所属公司",
          Remark: `${this.company}`
        });
      }
      if (this.year) {
        this.myModel.List.push({
          TypeId: -1,
          Value: "创立年份",
          Remark: `${this.year}`
        });
      }
      if (this.type) {
        this.myModel.List.push({
          TypeId: -1,
          Value: "店铺类型",
          Remark: `${this.type}`
        });
      }
      if (this.value) {
        this.myModel.List.push({
          TypeId: -1,
          Value: "单店投入",
          Remark: `${this.value}`
        });
      }
      if (this.value1) {
        this.myModel.List.push({
          TypeId: -1,
          Value: "研发人数",
          Remark: `${this.value1}`
        });
      }
      if (this.value2) {
        this.myModel.List.push({
          TypeId: -1,
          Value: "旗舰店",
          Remark: `${this.value2}`
        });
      }
      if (this.value3) {
        this.myModel.List.push({
          TypeId: -1,
          Value: "加盟店",
          Remark: `${this.value3}`
        });
      }
      this.$emit("sendField", this.myModel);
      this.$emit("refresh");
    }
  }
};
</script>

<style scope lang="scss">
.my-info {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 20px;
  &-box2 {
    width: 100%;
    font-size: 14px;
    color: #333;
    display: flex;
    padding-right: 10px;
  }
  &-box {
    width: 100%;
    &.z-half {
      width: 50%;
    }
    font-size: 14px;
    color: #333;
    display: flex;
    padding-right: 10px;
    margin-bottom: 20px;
    &-l {
      flex: 1;
      font-size: 14px;
      color: #333;
    }
    &-r {
      width: 84px;
    }
  }
  &-txt {
    width: 30px;
    line-height: 32px;
    display: inline-block;
  }
}
</style>
